import React from 'react';
import { FaSquarePhone } from "@react-icons/all-files/fa6/FaSquarePhone";
import ContactButton from 'day8-react/build/new-components/ContactUs/ContactButton';
var CallUsButton = function (_a) {
    var isYachtsAndFriends = _a.isYachtsAndFriends;
    return (React.createElement(ContactButton, { brand: isYachtsAndFriends ? 'ynf' : 'tyw', trigger: React.createElement("button", { className: 'dui-py-2 dui-px-4 dui-font-medium dui-flex dui-items-center dui-justify-center dui-gap-2 dui-cursor-pointer dui-rounded-full dui-bg-gray-100' },
            React.createElement("p", { className: ' dui-text-md dui-font-semibold' }, "Call us"),
            React.createElement(FaSquarePhone, { className: 'dui-text-lg' })) }));
};
export default CallUsButton;
